import { defineStore, acceptHMRUpdate } from 'pinia'

type UserInfo = {
  accessToken?: string
  gwId?: string
  isUrl?: boolean
  phone?: string
  nick?: string // 用户匿名字段，为空时app 不返回
  countryCode: string // 国家代码 默认+66
  country: string
  areaCode?: string // 国家手机区号，巴西固定+55
}

/**
 * 城市选择器数据存储
 */
const defaultUserState = {
  accessToken: '',
  gwId: '',
  isUrl: false,
  phone: '',
  nick: '', // 用户匿名字段，为空时app 不返回
  countryCode: '+66', // 国家代码 默认+66
  country: 'AU',
  areaCode: '+55', // 国家手机区号，巴西固定+55
}

const userStore = defineStore('userStore', {
  state: (): UserInfo => defaultUserState,
  actions: {
    SET_USER_INFO(payload: PartialNull<Partial<UserInfo>>) {
      this.accessToken = payload.accessToken || ''
      this.gwId = payload.gwId || ''
      this.isUrl = !!payload.isUrl
      this.phone = payload.phone || ''
      this.nick = payload.nick || ''
      this.countryCode = payload.countryCode || '+66'
      this.country = payload.country || 'AU'
    },
    SET_TOKEN(payload: string) {
      this.accessToken = payload
    },
    SET_COUNTRY(payload: string) {
      this.country = payload
    },
  },
})

export default userStore

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(userStore, import.meta.hot))
}
